import { getWorkspaceFrameStyles } from '@components/v2/constants';
import type { SidebarState } from '@components/v2/layout/AppTemplate/appTemplate.types';
import { makeStyles } from 'tss-react/mui';
import { RACHEL_PANEL_WIDTH } from '../../../../rachel/components/RachelPanel/rachelPanel.styles';

interface StyleParams {
  sidebarState: SidebarState;
  isRachelDocked: boolean;
}

export const useProductDetailsPanelStyles = makeStyles<StyleParams>()(
  (theme, { sidebarState, isRachelDocked }) => {
    const FRAME_PADDING = theme.spacing(1);
    const SIDEBAR_FRAME_GAP = sidebarState === 'collapsed' ? 0 : theme.spacing(0.25);
    const leftInset = sidebarState === 'hidden' ? FRAME_PADDING : SIDEBAR_FRAME_GAP;
    const rightInset = isRachelDocked
      ? `calc(${FRAME_PADDING} + ${RACHEL_PANEL_WIDTH}px)`
      : FRAME_PADDING;

    return {
      panel: {
        ...getWorkspaceFrameStyles(theme),
        position: 'absolute',
        zIndex: 1,
        top: 0,
        bottom: 0,
        left: leftInset,
        right: rightInset,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        overflow: 'hidden',
        [theme.breakpoints.down('sm')]: {
          left: 0,
          right: 0,
        },
      },
    };
  },
);
